import { GridCellProps } from '@progress/kendo-react-grid';
import useRedirectBtn from 'src/hooks/useRedirectBtn';

const DocumentField = (props: GridCellProps) => {
  const RedirectButton = useRedirectBtn(true, true);

  return <RedirectButton {...props} />;
};

export default DocumentField;
